export type StudyLevelValues =
  | 'PRE_BAC'
  | 'BAC'
  | 'BAC1'
  | 'BAC2'
  | 'BAC2_DIPLOMA'
  | 'BAC3'
  | 'BAC4'
  | 'BAC5';

export const studyLevels: StudyLevelValues[] = [
  'PRE_BAC',
  'BAC',
  'BAC1',
  'BAC2',
  'BAC2_DIPLOMA',
  'BAC3',
  'BAC4',
  'BAC5',
];

enum STUDY_LEVELS {
  PRE_BAC = 'Avant bac',
  BAC = 'Bac',
  BAC1 = 'Bac +1',
  BAC2 = 'Bac +2 non diplômant (ex: L2)',
  BAC2_DIPLOMA = 'Bac +2 diplômant (ex: BTS, DUT)',
  BAC3 = 'Bac +3',
  BAC4 = 'Bac +4',
  BAC5 = 'Bac +5 ou plus',
}
export default STUDY_LEVELS;
